/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { memo } from "react";

import "react-awesome-slider/dist/styles.css";

import { Dialog } from "@origin-digital/ods-core";

/**
 * A trigger component to show dialog
 */
export const DialogTrigger = memo(
  ({
    id,
    children,
    title,
    summary,
  }: {
    id: string;
    children: any;
    title: JSX.Element;
    summary: JSX.Element;
  }) => {
    const [showModal, setShowModal] = React.useState(false);
    const renderChildren = () => {
      return React.cloneElement(children as any, {
        onClick: () => {
          setShowModal(true);
        },
      });
    };

    return (
      <>
        {renderChildren()}
        <Dialog
          id={id}
          open={showModal}
          title={title}
          onClose={() => setShowModal(false)}
        >
          {summary}
        </Dialog>
      </>
    );
  }
);
